import { ApiCore } from "./core";
import { apiProvider } from "./core/provider";

const url = "reports";

const apiReports = new ApiCore({
  list: false,
  get: false,
  post: false,
  put: false,
  patch: false,
  delete: false,
  url: url,
});

apiReports.getZipCodeHeatMap = function(from, to) {
  const fromTimestamp = new Date(from).getTime();
  const toTimestamp = new Date(to).getTime();
  return apiProvider.get(`${url}/zipCodeHeatMap?from=${fromTimestamp}&to=${toTimestamp}`);
};

apiReports.getIncomingMap = function() {
  return apiProvider.get(`${url}/incoming-map`);
};

apiReports.getIncomingMonthlyTrend = function() {
  return apiProvider.get(`${url}/incoming-monthly-trend`);
};

apiReports.getMetricHistory = function(metric, days = 30) {
  return apiProvider.get(`${url}/metric-history?metric=${encodeURIComponent(metric)}&days=${days}`);
};

apiReports.getNewAreas = function() {
  return apiProvider.get(`${url}/new-areas`);
};

apiReports.getInspectorCoverage = function(minutes = 60) {
  return apiProvider.get(`${url}/inspector-coverage?minutes=${encodeURIComponent(minutes)}`);
};

export { apiReports };
